
const _client_urls = {create:"/client/create/",
                        orders:"/client/",
                        chat:"/client/?chat=true",
                        profile:"/client/profile/",
                        dash:"/client/profile/?dash=true"}

export {
    _client_urls }